module.exports = __webpack_public_path__ + "static/img/gc-logo.bc39208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gc-logo.png
// module id = 1jX/
// module chunks = 0